export { default } from "./palette.js";
export * from "./palette.js";